import { Card, CardContent, styled, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import StepNumberCircle from "./StepNumberCircle";

const StepItemContainerStyled = styled(Card)(({ cardWidth, cardMargin, cardMaxWidth }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: `${cardWidth}%`,
  maxWidth: `${cardMaxWidth}px`,
  margin: `0 ${cardMargin}px`,
  padding: 4,
  textAlign: "center",
  boxSizing: "border-box",
  scrollSnapAlign: "center",
  boxShadow: "0 2px 4px rgba(20, 90, 121, 0.1)",
  borderRadius: "8px",
  backgroundColor: "#FFF",
  userSelect: "none",
  "&:first-child": { marginLeft: 0 },
  "&:last-child": { marginRight: 0 },
  "& .MuiCardContent-root:last-child": { paddingBottom: "16px" }
}));

const formatLabel = (label = "", max = 10) => {
  return label.length > max ? `${label.slice(0, max)}...` : label;
}

const StepItemContainer = ({ 
  label, 
  index, 
  active, 
  completed,
  cardWidth = 70,
  cardMargin = 4,
  cardMaxWidth = 250,
  onClick = () => {}
}) => (
  <StepItemContainerStyled 
    cardWidth={cardWidth}
    cardMargin={cardMargin}
    cardMaxWidth={cardMaxWidth}
    active={active} 
    completed={completed}
    onClick={onClick}
  >
    <CardContent
      sx={{ 
        display: "flex",
        flex: 1,
        alignItems: "center"
      }}
    >
      <StepNumberCircle active={active} completed={completed}>
        {completed ? <FontAwesomeIcon icon={faCheck} /> : index + 1}
      </StepNumberCircle>
      <Typography 
        variant="h6"
        sx={{
          fontSize: active ? "20px !important" : "16px !important",
          fontWeight: active ? "700" : "500",
          color: active || completed ? "#155A79" : "#155A7966",
          margin: "0 auto !important",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
      >
        {formatLabel(label)}
      </Typography>
    </CardContent>
  </StepItemContainerStyled>
);

export default StepItemContainer;